import * as styled from "styled-components";

export const AppGlobalStyle = styled.createGlobalStyle`
  .ant-avatar-lg.ant-avatar-icon > .anticon {
    padding-top: 8px;
  }
`;
